class a {
  static async load(n) {
    if (!document.getElementById("beacon-user")) {
      const o = document.createElement("div");
      o.id = "beacon-user", document.body.appendChild(o);
      const e = document.createElement("script");
      e.src = "https://cdn.beacon.li/sdk/latest.js", e.async = !0, e.type = "module", document.body.appendChild(e), window.BeaconBar = window.BeaconBar || {}, window.BeaconBar.orgId = n, window.BeaconBar.open = () => {
        window.BeaconBar.opened = !0;
      };
    }
  }
  static open() {
    window.BeaconBar.open();
  }
  static close() {
    window.BeaconBar.close();
  }
  static setRouter(n) {
    window.BeaconBar.route = n;
  }
}
export {
  a as BeaconBar
};
